import React, { useEffect } from 'react';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Dropdown, Button } from '@openedx/paragon';

import { getConfig } from '@edx/frontend-platform';

import { fetchNotificationsData } from '../../data/thunks';
import { ReactComponent as BellIcon } from '../svgs/bellIcon.svg';
import NotificationItem from './NotificationItem';
import { NOTIFICATION_INTERVAL } from '../../config';
import messages from '../messages';

function NotificationMenu({ intl }) {
  const { data, isLoading } = useSelector((state) => state.app.notifications);
  const dispatch = useDispatch();
  const location = useLocation();

  const handleRedirect = async () => {
    window.open(
      `${getConfig().DASHBOARD_MFE_BASE_URL}/notifications`,
      '_blank',
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(fetchNotificationsData());
    }, NOTIFICATION_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    dispatch(fetchNotificationsData());
  }, [location]);

  return (
    <div className="notification-wrapper">
      <Dropdown>
        {!!data?.count && <span className="notify-bubble" />}
        <Dropdown.Toggle id="notification-menu-dropdown-toggle" aria-label="Notifications for user" className="bell-icon">
          <BellIcon />
        </Dropdown.Toggle>
        <Dropdown.Menu popperConfig={{ fixed: true }}>
          <div className="notify-header">
            <div className="notify-header-left">
              <h4>Unread Notifications</h4>
              <div className="notification-count">{data?.count || 0}</div>
            </div>
            <Button variant="link" onClick={handleRedirect}>
              View All
            </Button>
          </div>
          <div className="notification-list">
            {!data?.results?.length ? (
              <div className="empty-state-message">No Results Found</div>
            ) : (
              data.results.map((notification) => (
                <NotificationItem
                  notification={notification}
                  key={notification.slug}
                />
              ))
            )}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

NotificationMenu.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(NotificationMenu);
